import React from 'react';
import { ISectionList } from './types';
import { SectionItem } from './SectionItem';

export const SectionList = ({
    sections,
    vehicle,
    handleChange,
    handleChangeVehicle,
    isEditable,
}: ISectionList) => {
    return (
        <>
            {sections?.map((section, key) => (
                <SectionItem
                    section={section}
                    vehicle={vehicle}
                    handleChange={handleChange}
                    handleChangeVehicle={handleChangeVehicle}
                    isEditable={isEditable}
                    key={key}
                />
            ))}
        </>
    );
};
